import { useObserveElementWidthGroup } from "../../../../library/components/hooks/useObserveElementWidthGroup";
import { PDF_CANVAS_WIDE_LAYOUT_MIN_WIDTH } from "../pdfCanvasConstants";

export function usePdfDisplayerLayout() {
    const { sizeName: layoutSizeName, ref: containerRef } = useObserveElementWidthGroup<HTMLDivElement, "stacked" | "wide">({
        [PDF_CANVAS_WIDE_LAYOUT_MIN_WIDTH]: "stacked",
        10000: "wide",
    });

    return {
        containerRef,
        isWideLayout: layoutSizeName === "wide",
    };
}
